module.exports = __webpack_public_path__ + "img/wallet-1.bb22b602.svg";